import { render, staticRenderFns } from "./ExternalLoginPage.vue?vue&type=template&id=fbb80a22&"
import script from "./ExternalLoginPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalLoginPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports